@if (reminder()) {
  <p-dialog
    [visible]="true"
    header="Prospect Reminder"
    [modal]="true"
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    [baseZIndex]="20000"
    [style]="{ width: '480px', maxWidth: '92vw' }">
    <div class="flex flex-col gap-1">
      <div class="flex flex-wrap items-baseline gap-1 text-[15px] text-[var(--app-text)]">
        <span>Reminder for</span>
        @if (prospectName()) {
          <p-button
            type="button"
            [label]="prospectName()"
            [link]="true"
            styleClass="!p-0 !min-w-0 !text-[15px] !font-semibold !underline"
            (onClick)="onOpenProspect()" />
        } @else {
          <span class="font-semibold">{{ missingBusinessName }}</span>
        }
      </div>

      <p class="m-0 text-[12px] text-[var(--app-text-subtle)]">{{ scheduledLabel() }}</p>
    </div>

    <ng-template #footer>
      <div class="flex justify-end">
        <p-button type="button" label="DISMISS" icon="pi pi-check" size="small" (onClick)="onDismiss()" />
      </div>
    </ng-template>
  </p-dialog>
}
